<template>
  <div>
    <VisualizationBackbeatLayout :leftInfo="leftInfo" :leftAction="leftAction">
      <template slot="rightAction">
        <div
          class="custom-competence-backbeat d-flex align-content-end flex-wrap ml-auto"
        >
          <div class="p-2 competence align-self-center">
            COMPETÊNCIA:
          </div>
          <div class="p-1 align-self-center">
            <vue-monthly-picker
              class="periodo"
              v-model="selectedDate"
              :monthLabels="this.allMonth"
              dateFormat="MM/YYYY"
              :max="this.maxDate"
            ></vue-monthly-picker>
          </div>
        </div>
      </template>
      <template slot="headerContent">
        <div class="div-principal">
          <div class="d-flex">
            <div
              class="d-flex align-content-center flex-wrap"
              v-if="!dataBackBeat || Object.keys(dataBackBeat).length == 0"
            >
              <h5>                
                Não há dados para o período informado! Tente consultar outro
                período.
              </h5>
            </div>
          </div>
          <div class="resultado-coletivo" v-if="dataBackBeat && Object.keys(dataBackBeat).length > 0">            
            <div>
              <p class="p-accumulated">
                <img
                  class="img-Accumulated"
                  src="../../../assets/images/MDI-information-green.svg"
                />
                Acumulado até {{ this.dataBackBeat.solicitation }}.
              </p>
            </div>
            <div class="div-value-pago mt-3">
              <BaseLayoutCustom>
                <template slot="componentOne">
                  <CardResultBase
                    title="VALOR PAGO PARA O COOPERADO"
                    customColor="primary"
                    :infoValue="'R$ ' + this.dataBackBeat.amountPaid"
                    :onAction="onClickSaibaMais"
                  />
                </template>
                <template slot="componentTwo">
                  <CardResultBase
                    title="RESULTADO TOTAL"
                    customColor="green-3"
                    :infoValue="this.dataBackBeat.resultCollective"
                    :onAction="onClickSaibaMais"
                    typeAction="RT"
                  />
                </template>
              </BaseLayoutCustom>
              <BaseLayoutResultGeneric
                id="1"
                class="mt-5"
                title="Resultado Coletivo"
              >
                <template slot="body">
                  <BaseLayoutCustom>
                    <template slot="componentOne">
                      <CardResultBase
                        title="META"
                        customColor="green-3"
                        infoDetail="menor que"
                        :infoValue="this.dataBackBeat.goal"
                        :onAction="onClickSaibaMais"
                        typeAction="MT"
                        :showImgMeta="true"
                      />
                    </template>
                    <template slot="componentTwo">
                      <CardResultBase
                        title="ÍNDICE DE SINISTRALIDADE"
                        :infoDetail="
                          !this.dataBackBeat.isLossRatio
                            ? 'a meta foi alcançada!'
                            : 'a meta não foi alcançada.'
                        "
                        :customColor="
                          !this.dataBackBeat.isLossRatio
                            ? 'primary'
                            : 'orange-2'
                        "
                        :infoValue="this.dataBackBeat.lossRatio"
                        :onAction="onClickSaibaMais"
                        typeAction="IS"
                        :goalExceeded="!this.dataBackBeat.isLossRatio"
                      />
                    </template>
                  </BaseLayoutCustom>
                </template>
              </BaseLayoutResultGeneric>
              <BaseLayoutResultGeneric
                id="2"
                class="mt-5"
                title="Resultado Individual"
              >
                <template slot="body">
                  <BaseLayoutCustom>
                    <template slot="componentOne">
                      <CardIndividualResult
                        title="DESEMPENHO ADMINISTRATIVO"
                        :items="this.administrativePerformanceItems"
                        :onAction="onClickSaibaMais"
                        :porcentage="
                          this.dataBackBeat.additionalGainPerformance
                        "
                        typeAction="RRT"
                      />
                    </template>
                    <template slot="componentTwo">
                      <CardIndividualResult
                        title="PACOTE TECNOLÓGICO"
                        :items="this.technologyPackageItems"
                        :onAction="onClickSaibaMais"
                        :porcentage="
                          this.dataBackBeat.additionalGainTechnologicalPackage
                        "
                        typeAction="PT"
                      />
                    </template>
                  </BaseLayoutCustom>
                </template>
              </BaseLayoutResultGeneric>
              <TechnicalEfficiency
                class="mt-5"
                :additionalGainTechnicalEfficiency="
                  this.dataBackBeat.additionalGainTechnicalEfficiency
                "
                :items="this.items"
                :onAction="onClickSaibaMais"
                :loading="this.globalLoading"
              />
              <div
                v-show="true"
                class="help--internal mt-5"
                @click="onClickBackbeatSaibaMais()"
              >
                SAIBA MAIS SOBRE O BACKBEAT
                <img
                  v-show="true"
                  class="mdi-chevron-right"
                  src="../../../assets/images/mdi-chevron-right.svg"
                />
              </div>
            </div>
          </div>
        </div>
        <success-modal-custom
          v-if="dataBackBeat && Object.keys(dataBackBeat).length > 0"
          :title="this.title"
          ref="success-modal"
          buttonText="Ok, entendi!"
          :typeAction="this.typeAction"
          :isLossRatio="this.dataBackBeat.isLossRatio"
          :goal="this.dataBackBeat.goal"
          :lossRatio="this.dataBackBeat.lossRatio"
        />
        <SuccessModalCustomBigger
          :title="this.title"
          ref="success-modal-two"
          buttonText="Ok, entendi!"
          :typeAction="this.typeAction"
        />
      </template>
    </VisualizationBackbeatLayout>
  </div>
</template>

<script>
import SuccessModalCustom from "../components/visualization/SuccessModalCustom.vue";
import VisualizationBackbeatLayout from "../components/visualization/VisualizationBackbeatLayout.vue";
import { allMonth, getMonthNumber } from "../../../utils/date/date-utils";
import moment from "moment";
import { getDetailsBackbeatAPI } from "../../../services/backbeat/backbeat-services";
import { inject } from "@vue/composition-api";
import { isMobile } from "../../../utils/mobile/mobile";
import RoutesPaths from "../../../router/router-structure/routes-paths";
import { getCompetences } from "../../../services/analytics/analytics-services";
import CardResultBase from "./CardResultBase.vue";
import BaseLayoutCustom from "../components/visualization/BaseLayoutCustom.vue";
import BaseLayoutResultGeneric from "../components/visualization/BaseLayoutResultGeneric.vue";
import TechnicalEfficiency from "../components/visualization/TechnicalEfficiency.vue";
import CardIndividualResult from "./CardIndividualResult.vue";
import SuccessModalCustomBigger from "../components/visualization/SuccessModalCustomBigger.vue";

export default {
  components: {
    VisualizationBackbeatLayout,
    SuccessModalCustom,
    CardResultBase,
    CardIndividualResult,
    BaseLayoutCustom,
    BaseLayoutResultGeneric,
    TechnicalEfficiency,
    SuccessModalCustomBigger,
  },
  async mounted() {
    try {
      this.globalLoading = true;
      this.allMonth = allMonth();
      const competenceString = await this.getCompetence();
      let competence = competenceString[0]?.competence;
      this.maxDate = moment(competence, "MM/YYYY");
      const isValid = (value) => {
        return !value || value.trim() === "";
      };

      if (isValid(competence)) {
        this.dataBackBeat = {};
        this.selectedDate = moment();
      } else {
        this.selectedDate = moment(competence, "MM/YYYY");
      }
    } catch (e) {
      this.globalLoading = false;
    }
  },
  watch: {
    selectedDate: {
      handler() {
        this.year = this.getYear();
        this.month = this.getMonth();
        this.getDetailsBackbeatHandler();
      },
    },
  },
  computed: {
    yearsOptions: () => {
      let years = [];
      for (var n = 2017; n <= new Date().getFullYear(); n++) {
        years.push(n);
      }
      return years.reverse();
    },
  },
  setup() {
    const globalLoading = inject("globalLoading");
    return { globalLoading };
  },
  data() {
    return {
      maxDate: null,
      dataBackBeat: {},
      allMonth: null,
      selectedDate: "",
      year: new Date().getFullYear(),
      leftAction: {
        text: "Backbeat",
        onClick: this.leftActionClickHandler,
      },
      leftInfo: "",
      fields: [],
      items: [],
      selectedViewRequestItem: null,
      requestTypeDescription: "",
      selectedAttachments: [],
      administrativePerformanceItems: [],
      technologyPackageItems: [],
      typeAction: null,
      title: null,
    };
  },
  methods: {
    isMobile: isMobile,
    async onGetDescriptionPaid() {
      return "R$ " + this.dataBackBeat.amountPaid;
    },
    async getCompetence() {
      let loading = this.globalLoading;
      try {
        if (!loading) this.globalLoading = true;
        const resp = getCompetences();
        if (!loading) this.globalLoading = false;
        return resp;
      } catch (error) {
        if (!loading) this.globalLoading = false;
        console.error("getCompetence", error);
      }
    },
    onClickBackbeatSaibaMais() {
      this.$router.push({
        path: RoutesPaths.financial.backbeatKnowMore(),
        replace: true,
      });
    },
    getYear() {
      return this.selectedDate.format("YYYY");
    },
    getMonth() {
      return this.selectedDate.format("MM");
    },
    async getDetailsBackbeatHandler() {
      try {
        this.globalLoading = true;
        const crm = this.$store.getters.getUserName;

        this.dataBackBeat = await getDetailsBackbeatAPI(
          crm,
          this.year,
          getMonthNumber(this.month)
        );
        this.buildAdministrativePerformance();
        this.buildTechnologyPackageItems();
        this.items = this.dataBackBeat?.technicalEfficiency;
        this.globalLoading = false;
      } catch (error) {
        this.dataBackBeat = {};
        this.globalLoading = false;
        console.error("getDetailsBackbeatHandler", error);
      }
    },
    buildTechnologyPackageItems() {
      this.technologyPackageItems = [];
      if (this.dataBackBeat) {
        this.technologyPackageItems.push({
          check: this.dataBackBeat.isAdditionalGainTechnologicalPackage,
          description: "Disponilização de horários para agendamento pelo HUB",
        });
      }
    },
    buildAdministrativePerformance() {
      if (this.dataBackBeat) {
        this.administrativePerformanceItems = [];
        this.administrativePerformanceItems.push({
          check: this.dataBackBeat.minimumProduction,
          description: "Cumprimento da produção mínima",
        });
        this.administrativePerformanceItems.push({
          check: this.dataBackBeat.participationMeeting,
          description: "Participação assembleia",
        });
        this.administrativePerformanceItems.push({
          check: this.dataBackBeat.nonPayment,
          description: "Obrigações financeiras",
        });
      }
    },
    leftActionClickHandler() {
      this.$router.go(-1);
    },
    onGetAdicional(value) {
      return "Ganho adicional: " + value;
    },
    async onClickSaibaMais(type, title) {
      let nameRef = "success-modal";
      if (type === "RRT") {
        title = "Saiba mais sobre os Indicadores Administrativos";
        nameRef = "success-modal-two";
      } else if (type === "PT") {
        title = "Saiba mais sobre o Pacote Tecnológico";
        nameRef = "success-modal-two";
      } else if (type === "IT") {
        title = "Saiba mais sobre os Indicadores Técnicos";
        nameRef = "success-modal-two";
      }

      this.typeAction = type;
      this.title = title;
      let modal = this.$refs[nameRef].$children[0];
      if (modal != null) modal.show();
    },
  },
};
</script>
<style lang="scss" scoped>
.div-principal {
  width: 100%;
}
.resultado-coletivo {
  width: 100%;
  padding-top: 0rem;
}
.img-Accumulated {
  height: 1.2rem;
  width: 1.2rem;
}
.p-accumulated {
  color: var(--green-2);
  font-size: multiplier-default-font-size(2); //14px
}
</style>
<style lang="scss">
.help {
  margin-top: 5.2rem;
  width: 100%;

  &--internal {
    display: flex;
    align-items: center;
    padding: 0 1rem 0 2rem;
    cursor: pointer;
    border-radius: 1rem;
    font-size: multiplier-default-font-size(3); // 16px

    background-color: white;
    color: #459b64;
    width: 100%;
    text-align: left;
    padding-left: 1.4rem;
    height: 5rem;
    margin-bottom: 2.5rem;

    img {
      margin-left: auto;
    }
  }
}
.custom-competence-backbeat {
  margin-top: 0rem;
}
@media (max-width: 450px) {
  .custom-competence-backbeat {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}
</style>
